export default function (el) {
  el.classList.add('readonly')
  el.onkeydown = function(event) {
    event.preventDefault();
  }
  el.oncontextmenu = function(event) {
    event.preventDefault();
  }
}